import { useState, useCallback } from "react";

// Favoriten-Verwaltung (localStorage-persistiert) für die Navigation.
export function useNavFavorites(allNavItems) {
  const [favorites, setFavorites] = useState(() => {
    try { const raw = localStorage.getItem("nav-favorites"); const p = raw ? JSON.parse(raw) : []; return Array.isArray(p) ? p : []; } catch { return []; }
  });

  const persist = (next) => {
    try { localStorage.setItem("nav-favorites", JSON.stringify(next)); } catch (e) { console.error("Favoriten konnten nicht gespeichert werden:", e); }
    return next;
  };

  const toggleFavorite = useCallback((path) => {
    setFavorites((prev) => persist(prev.includes(path) ? prev.filter((p) => p !== path) : [...prev, path]));
  }, []);

  const handleFavDragEnd = useCallback((event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    setFavorites((prev) => {
      const oldIndex = prev.indexOf(active.id);
      const newIndex = prev.indexOf(over.id);
      if (oldIndex < 0 || newIndex < 0) return prev;
      const reordered = [...prev];
      const [moved] = reordered.splice(oldIndex, 1);
      reordered.splice(newIndex, 0, moved);
      return persist(reordered);
    });
  }, []);

  const favoriteItems = favorites
    .map((p) => allNavItems.find((i) => i.path === p))
    .filter(Boolean);

  return { favorites, favoriteItems, toggleFavorite, handleFavDragEnd };
}
